<style scoped>
.dot {
  height: 10px;
  width: 10px;
  background-color: #ed4014;
  border-radius: 50%;
  display: inline-block;
  margin-left: 5px;
}
.ivu-card-bordered {
  border: 0 !important;
}
.addMargin {
  margin-top: 10px;
}
.avatar {
  position: unset;
  width: 100px;
  /* border-radius: 115px; */
  border-radius: 50px;
  height: 100px;
}
.column {
  display: flex;
  flex-direction: column;
}
.center {
  display: flex;
  justify-content: center;
}
.order-1 {
  order: 1;
}
.order-2 {
  order: 2;
}
.order-3 {
  order: 3;
}
.order-4 {
  order: 4;
}
.order-5 {
  margin-top: 10px;
  order: 5;
}
.ivu-avatar-o {
  background-color: transparent;
  color: black;
}

.ivu-badge-count-0 {
  left: -8px;
  bottom: 7px;
}
.atFooter {
  display: flex;
  /* background-color: aqua; */
  position: fixed;
  bottom: 0px;
  width: 100%;
  height: 40px;
}

.menu-icon-bullet {
  display: inline-block;
  height: 10px;
  width: 10px;
  border-radius: 50%;
  background: #657180;
}

@media (min-width: 768px) {
  .notification-button {
    display: none;
  }
}
@media (min-width: 768px) and (max-width: 800px) {
  .app-version{
    margin-top: 15px !important;
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
}
</style>

<style lang="scss">
.menu-page-template {
  .ivu-avatar-o .ivu-icon {
    font-size: 22px !important;
  }
  .ivu-dropdown .ivu-select-dropdown {
    width: 300px;
    height: 300px;
    overflow: hidden;
    overflow-y: auto;
  }
}
</style>

<template>
  <app-layout class="menu-page-template">
    <div class="flex-container column" style="margin-top: -80px;">
      <div class="order-1" style="margin-left:15px; margin-bottom:10px;">
        <p style="font-size:10px; padding: 5px 0 0 5px;color:#aaa">
          <span style="position:absolute;right:0;top:10;padding:0 10px 0 0px;">
            <a style="color:#333" @click="dismiss()">
              <!-- <svg style="vertical-align: middle" xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg> -->
              <img alt=" " style="height:25px; width:25px;" src="@/assets/close.png" />
            </a>
          </span>
        </p>
      </div>
      <!-- {{ userInfo}} -->
      <div
        class="order-2 center"
        v-if="userInfo && 'avatar' in userInfo && userInfo.avatar"
        @click="$store.dispatch('statistics/postStats', {stat_type: 'link', link_tag: 'View Profile'});dismiss()"
      >
        <router-link class="pointer" tag="span" :to="`/profile/${userInfo.id}`">
          <img
            style="margin-bottom:10px;border:1px solid #ddd;background:white;"
            class="avatar"
            :src="(userInfo && 'avatar' in userInfo && userInfo.avatar) ? userDisplayImage(userInfo): profilePlaceholder"
            width="100px"
            height="100px"
            alt=" "
          />
        </router-link>
      </div>
      <p class="order-3 center" style="margin-top:-10px;font-size:14px;">
        <b>{{(userInfo) ? ( (userInfo && userInfo.user_type == "guest") ? 'Guest' : userInfo.display_name) : 'Guest'}}</b>
      </p>
      <div
        class="order-4 center"
        style="padding:0 20px;font-size:10px;margin-top:5px;"
        v-if="userInfo && userInfo.user_type === 'guest'"
        @click="dismiss()"
      >
        <button
          class="ivu-btn ivu-btn-default ivu-btn-text"
          @click="$store.dispatch('statistics/postStats', {stat_type: 'link', link_tag: 'Guest Click Sign In'});setMemberMethod('signin')"
          style="color:var(--link-color);font-weight:bold"
        >Already a Member</button>&nbsp;
        <button
          v-show="false"
          class="ivu-btn ivu-btn-error"
          @click="$store.dispatch('statistics/postStats', {stat_type: 'link', link_tag: 'Guest Click Sign Up'});setMemberMethod('signup')"
        >Join</button>
      </div>
      <!-- <div class="order-4 center" style="height: 20px;line-height: 20px;font-size:10px;margin-top:5px;"  v-if="userInfo && userInfo.user_type !== 'guest'" @click="dismiss()">
      <router-link to="/profile">-->
      <!-- <p v-if="notificationCount>0" style="padding-top:2px;">View Profile</p> -->
      <!-- <p v-else>View Profile</p> -->
      <!-- <p>View Profile</p>
        </router-link>
        &nbsp; | &nbsp;
        <router-link to="/notifications">
          <p>
            Notifications
            <Badge :count="notificationCount" overflow-count="99"></Badge>
          </p>
        </router-link>
      </div>-->
      <div class="order-5">
        <div v-if="userInfo && userInfo.user_type !== 'guest'">
          <div
            v-if="getUserBrands && getUserBrands.data && getUserBrands.data.data.length > 1"
            style="padding: 0 25px 5px;text-align:center"
          >
            <Dropdown class="drpdwn" @on-click="onSwitchBrand" trigger="click" style="width:100%">
              <Button long size="large" href="javascript:void(0)" style="text-align:left">
                <Avatar :src="userDisplayImage(setBrand)" />&nbsp;
                <span
                  class="truncate"
                  style="width: 200px;display: inline-block;vertical-align: middle;"
                >{{setBrand.display_name}}</span>
                <Icon type="arrow-down-b"></Icon>
              </Button>
              <DropdownMenu slot="list" style="text-align:left;">
                <DropdownItem v-for="(item, i) in getUserBrands.data.data" :key="i" :name="item.id">
                  <p style="font-size:13px" class="truncate">
                    <Avatar :src="userDisplayImage(item)" />
                    {{item.display_name}}
                  </p>
                </DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </div>
        </div>
        <div class="stl-drawer-items">
          <Card
            v-if="userInfo && userInfo.user_type !== 'guest'"
            dis-hover
            style="cursor:pointer;height:33px"
            class="notification-button"
            :style="{ borderRadius: '0'}"
            :padding="5"
          >
            <div
              style="padding: 3px 20px"
              @click="$store.dispatch('statistics/postStats', {stat_type: 'link',  stat_id: item.id, link_tag: 'View Home'});viewPage('/home', false)"
            >
              <div class="menu-icon-bullet" />&nbsp; Home
            </div>
          </Card>
          <Card
            v-if="userInfo && userInfo.user_type !== 'guest'"
            dis-hover
            style="cursor:pointer;height:33px"
            class="notification-button"
            :style="{ borderRadius: '0'}"
            :padding="5"
          >
            <div
              style="padding: 3px 20px"
              @click="$store.dispatch('statistics/postStats', {stat_type: 'link', link_tag: 'View notifications'});dismiss();showNotifications()"
            >
              <!-- <Avatar class="ivu-avatar-o" icon="android-notifications-none" size="small" shape="square"></Avatar> -->
              <div class="menu-icon-bullet" />&nbsp; Notifications
              <span v-if="notificationCount" class="dot"></span>
            </div>
          </Card>
          <Card
            dis-hover
            style="cursor:pointer;height:33px"
            :style="{ borderRadius: '0'}"
            :padding="5"
            v-for="(item,k) in menuList"
            :key="k"
            v-show="showCallToActionMenu(item)"
          >
            <div v-if="item.id==4" style="padding: 3px 20px" @click="$store.dispatch('statistics/postStats', {stat_type: 'activity_link',  stat_id: item.item_id, link_tag: item.label});dismiss();showInviteOthers()">
              <!-- <Icon v-if="!item.noArrow && isMobile" type="chevron-right" style="float:right;margin-top:3px"></Icon> -->
              <!-- <Avatar class="ivu-avatar-o" :icon="item.icon" size="small" shape="square"></Avatar> -->
              <div class="menu-icon-bullet" />
              &nbsp; {{item.label}}
            </div>
            <div
              v-else-if="item.id==8"
              style="padding: 3px 20px"
              @click="$store.dispatch('statistics/postStats', {stat_type: 'activity_link',  stat_id: item.item_id, link_tag: item.label});dismiss();showCallToAction()"
            >
              <!-- <Avatar class="ivu-avatar-o" :icon="item.icon" size="small" shape="square"></Avatar> -->
              <div class="menu-icon-bullet" />
              &nbsp; {{item.label}}
            </div>
            <div
              v-else
              style="padding: 3px 20px"
              class="truncate"
              @click="$store.dispatch('statistics/postStats', {stat_type: 'activity_link',  stat_id: item.item_id, link_tag: item.label});viewPage(item.link, false)"
            >
              <!-- <Icon v-if="!item.noArrow && isMobile" type="chevron-right" style="float:right;margin-top:3px"></Icon> -->
              <!-- <Avatar
                class="ivu-avatar-o"
                :icon="item.icon"
                :src="item.src"
                size="small"
                shape="square"
              ></Avatar>-->
              <div class="menu-icon-bullet" />
              &nbsp; {{item.label}}
            </div>
          </Card>
          <Card
            dis-hover
            style="cursor:pointer;height:33px"
            :style="{ borderRadius: '0'}"
            :padding="5"
            v-if="!this.isMobile && isAdminStudio && userInfo && userInfo.user_type !== 'guest'"
            v-show="showCallToActionMenu(retake)"
            :class="(retake.break) ? 'addMargin': ''"
          >
            <div style="padding: 3px 20px" class="truncate" @click="$store.dispatch('statistics/postStats', {stat_type: 'link', link_tag: 'Retake Onboarding'});viewPage(retake.link, false)">
              <!-- <Icon v-if="!item.noArrow && isMobile" type="chevron-right" style="float:right;margin-top:3px"></Icon> -->
              <!-- <Avatar
                class="ivu-avatar-o"
                :icon="retake.icon"
                :src="retake.src"
                size="small"
                shape="square"
              ></Avatar>-->
              <div class="menu-icon-bullet" />
              &nbsp; {{retake.label}}
            </div>
          </Card>
          <Card
            dis-hover
            style="cursor:pointer;height:33px"
            :style="{borderRadius: '0'}"
            :padding="5"
            v-if="userInfo && userInfo.user_type !== 'guest' && getUserBrands && getUserBrands.data && getUserBrands.data.data.length > 1"
          >
            <div
              style="padding: 3px 20px"
              @click="$store.dispatch('statistics/postStats', {stat_type: 'link', link_tag: 'App Switcher'});viewPage(`/${$route.params.brandSlug}/app-selector`, false)"
            >
              <div class="menu-icon-bullet" />&nbsp; App Switcher
            </div>
          </Card>
          <Card
            dis-hover
            style="cursor:pointer;height:33px"
            :style="{borderRadius: '0'}"
            :padding="5"
            v-if="userInfo && userInfo.user_type === 'guest'"
          >
            <div style="padding: 3px 20px" @click="viewPage('/login?type=signin', true)">
              <!-- <Avatar icon="person" size="small" shape="square"></Avatar> &nbsp; Login -->
              <!-- <Avatar class="ivu-avatar-o" icon="log-in" size="small" shape="square"></Avatar> -->
              <div class="menu-icon-bullet" />&nbsp; Login
            </div>
          </Card>
          <Card
            dis-hover
            style="cursor:pointer;height:33px"
            :style="{color: '#aaa',borderRadius: '0'}"
            :padding="5"
            v-if="userInfo && userInfo.user_type !== 'guest'"
          >
            <div style="padding: 3px 20px" @click="$store.dispatch('statistics/postStats', {stat_type: 'link', link_tag: 'Signout'});viewPage('signout', false)">
              <!-- <Avatar icon="person" size="small" shape="square"></Avatar> &nbsp; Logout -->
              <!-- <Avatar class="ivu-avatar-o" icon="android-exit" size="small" shape="square"></Avatar> -->
              <div class="menu-icon-bullet" />&nbsp; Logout
            </div>
          </Card>
          <Card
            dis-hover
            style="cursor:pointer;height:55px; width:100%; position: fixed; bottom: 33px; background: transparent;"
            :style="{borderRadius: '0'}"
            :padding="10"
          >
            <div
              style="padding: 3px 0;text-align:center;font-size:15px"
              v-on:click="dismiss();openAboutModal()"
            >
              <div
                style=" display: flex;align-items: center;align-content: center;justify-content: center;margin-top: 10px;"
              >
                <!-- <Avatar style="vertical-align:middle" class="ivu-avatar-o" :src="mLogo" shape="square"></Avatar> <i>Powered by MYND</i> -->
                <img
                  src="@/assets/sharpen-left-violet.png"
                  style="width: 120px; vertical-align: middle"
                />
              </div>
            </div>
          </Card>
        </div>
        <p class="app-version"
          align="right"
          style="font-size:12px;padding:8px 10px;margin-top:20px;border-top:1px solid #f2f2f2;color: #aaa"
        >
          <b @click="devTools()">
            <div v-html="version"></div>
          </b>
          {{myStory ? myStory.title : 'Default'}}
        </p>
      </div>
    </div>
    <!-- <div class="atFooter center"> -->
    <!-- <p class="order-1"><Avatar size="small" :src="logo"></Avatar></p> -->
    <!-- <Avatar class="ivu-avatar-o" :scr="myndLogo" size="small" shape="square"></Avatar> -->
    <!-- </div> -->
    <AboutMyndModal></AboutMyndModal>
    <ReportModalComponent :type="reportType" v-if="reportType" @closeModal="reportType = null"></ReportModalComponent>
  </app-layout>
</template>

<script>
var pjson = require("@/../package.json");

import VueCookie from "vue-cookie";
import logo from "@/assets/logo.png";
import mLogo from "@/assets/mind-logo.png";
import Utils from "@/utils.js";
import { Message } from "iview";
import AboutMyndModal from "@/components/AboutMyndModal";
import ReportModalComponent from "@/components/ReportModalComponent";
import { mapGetters } from "vuex";
import _ from "lodash";

export default {
  name: "MenuComponent",
  components: {
    AboutMyndModal,
    ReportModalComponent
  },
  computed: {
    aboutUs() {
       if (_.get(this.brandInfo, "resource_id.about_us"))
        return _.get(this.brandInfo, "resource_id.about_us");
      else if (_.get(this.brandInfo, "network_resource.about_us"))
        return _.get(this.brandInfo, "network_resource.about_us");
      else return _.get(this.brandInfo, "global_resource.about_us");
    },
    aboutApp() {
       if (_.get(this.brandInfo, "resource_id.about_app"))
        return _.get(this.brandInfo, "resource_id.about_app");
      else if (_.get(this.brandInfo, "network_resource.about_app"))
        return _.get(this.brandInfo, "network_resource.about_app");
      else return _.get(this.brandInfo, "global_resource.about_app");
    },
    menuList() {
      return [
        // { label: 'Home', link: '/home' },
        // { label: 'About', link: '/about-us' },
        // { label: 'Contact Us', link: '/contact-us' },
        // { label: 'News', link: '/feed', break: 1 },
        // { label: 'Profile', link: '/profile' },
        // { label: 'Groups', link: '/resources/list?type=groups' },
        // { label: 'Events', link: '/events' },
        // { label: 'Organization', link: '/organization' },
        // { label: 'Advocacies', link: '/advocacies'},
        // { label: 'Special Projects', link: '/special-projects' },
        // { label: 'Artwork', link: '/artwork' },
        // { label: 'Recommended', link: '/coming-soon' },
        // { label: 'FAQ', link: '/coming-soon' },
        // { label: 'Settings', link: '#'},
        // {
        //   id: 10,
        //   label: "Notifications",
        //   link:
        //     "/notifications/",
        //   icon: "android-notifications-none"
        // },
        {
          id: 1,
          item_id: this.aboutUs,
          label: "About Us",
          link: !this.aboutUs
            ? ""
            : "/" +
              this.$route.params.brandSlug +
              "/feed/" +
              this.aboutUs,
          icon: "ios-people-outline"
        },
        {
          id: 2,
          item_id: this.aboutApp,
          label: "About The App",
          link: !this.aboutApp
            ? ""
            : "/" +
              this.$route.params.brandSlug +
              "/feed/" +
              this.aboutApp,
          icon: "ios-people-outline"
        },
        {
          id: 3,
          item_id: Cons[0].MENU_COMPONENT.contact_us,
          label: "Contact Us",
          link:
            "/" +
            this.$route.params.brandSlug +
            "/feed/" +
            Cons[0].MENU_COMPONENT.contact_us,
          icon: "ios-email-outline"
        },
        // { id:3, label: 'Donate', link: '/donate?rid=' + Cons[0].GROUP_ID.donate, icon: 'ios-heart-outline'},
        // { id:8, label: 'Call to Action', link: '#', icon: 'speakerphone'},
        // { id:4, label: 'Invite Others To Join', link: '#', icon: 'android-share-alt'},
        // { id:5, label: 'Register Organization', link: '/create-organization', src: require('@/assets/org.png')},
        {
          id: 6,
          item_id: this.privacyPolicy,
          label: "Privacy Policy",
          link:
            "/" +
            this.$route.params.brandSlug +
            "/feed/" +
            this.privacyPolicy,
          icon: "document"
        },
        {
          id: 7,
          item_id: this.termsCondition,
          label: "Terms & Conditions",
          link:
            "/" +
            this.$route.params.brandSlug +
            "/feed/" +
            this.termsCondition,
          icon: "document"
        }
        // {
        //   id: 9,
        //   label: "Retake Onboarding",
        //   link: "/" + this.$route.params.brandSlug + "/onboarding",
        //   icon: "document"
        // }
      ];
    },
    termsCondition() {
      if (_.get(this.brandInfo, "resource_id.terms_and_conditions"))
        return _.get(this.brandInfo, "resource_id.terms_and_conditions");
      else if (_.get(this.brandInfo, "network_resource.terms_and_conditions"))
        return _.get(this.brandInfo, "network_resource.terms_and_conditions");
      else if (_.get(this.brandInfo, "global_resource.terms_and_conditions"))
        return _.get(this.brandInfo, "global_resource.terms_and_conditions");
      else 
        return Cons[0].MENU_COMPONENT.terms_conditions
    },
    privacyPolicy() {
      if (_.get(this.brandInfo, "resource_id.privacy_policy"))
        return _.get(this.brandInfo, "resource_id.privacy_policy");
      else if (_.get(this.brandInfo, "network_resource.privacy_policy"))
        return _.get(this.brandInfo, "network_resource.privacy_policy");
      else if (_.get(this.brandInfo, "global_resource.privacy_policy"))
        return _.get(this.brandInfo, "global_resource.privacy_policy");
      else 
        return Cons[0].MENU_COMPONENT.privacy_policy
    },
    showSuccess: {
      get() {
        return this.$store.state.share.showSuccess;
      }
    },
    notificationCount() {
      // return this.$store.state.notification.status.new;
      // TODO:
      return this.$store.state.notification.data.filter(notification => {
        return notification.is_new;
      }).length;
    },
    myndLogo: {
      get() {
        return require("@/assets/mynd.png");
      }
    },
    userInfo: {
      get() {
        return this.$store.state.user.info;
      }
    },
    isMobile: {
      get() {
        return this.$store.state.isMobile;
      }
    },
    version() {
      if (VueCookie.get("ios_app_version"))
        return `<div>iOS Build ${VueCookie.get(
          "ios_app_version"
        )}</div>Version ${pjson.version}`;
      return `Version ${pjson.version}`;
    },
    ...mapGetters({
      myUserStories: "brand/getPackageStories",
      brandInfo: "user/brandInfo"
    }),
    ...mapGetters('library', [
            'myStory']),
    isAdminStudio() {
      let isAccess = false;
      let accessList = _.get(this.brandInfo, "permission", []);
      accessList.forEach(element => {
        if (element === "brand_studio") isAccess = true;
      });
      return isAccess;
    },
    ...mapGetters("brand", ["getUserBrands"]),
    selectedBrand: {
      get() {
        let i = _.findIndex(this.getUserBrands.data.data, {
          id: this.brandInfo.id
        });
        this.setBrand = this.getUserBrands.data.data[i];
        return this.setBrand;
      },
      set(v) {
        this.setBrand = v;
      }
    }
  },
  data() {
    return {
      // showInvite: false,
      logo,
      mLogo,
      setBrand: null,
      profilePlaceholder: require("@/assets/person-placeholder.png"),
      retake: {
        id: 9,
        label: "Retake Onboarding",
        link:
          "/" +
          this.$route.params.brandSlug +
          "/onboarding?skip_user_info_verification=true",
        icon: "document"
      },
      reportType: null,
      devToolsLimit: 10,
      devToolsCount: 0,
      devToolsTimer: null
    };
  },
  mounted() {
    this.setBrand = this.brandInfo;
  },
  watch: {
    brandInfo(n) {
      this.setBrand = n;
    }
  },
  methods: {
    devTools() {
      this.devToolsCount++;
      if (this.devToolsCount < this.devToolsLimit) {
        clearTimeout(this.devToolsTimer);
        this.devToolsTimer = setTimeout(() => {
          this.devToolsCount = 0;
        }, 4000);
      } else {
        clearTimeout(this.devToolsTimer);
        this.devToolsCount = 0;
        window.webkit.messageHandlers.onNativeCalled.postMessage({
          name: "onDevTools"
        });
      }
    },
    iosAppSwitch(appSlug) {
      window.webkit.messageHandlers.onNativeCalled.postMessage({
        name: "onSwitchApp",
        params: {
          slug: appSlug
        }
      });
    },
    onSwitchBrand(n) {
      this.$store.dispatch('statistics/postStats', {
        stat_type: 'link',
        stat_id: n,
        link_tag: 'Menu Switch Network Dropdown'
      });
      let i = _.findIndex(this.getUserBrands.data.data, { id: n });
      this.setBrand = this.getUserBrands.data.data[i];
      BroadcastEvent.$emit("onToggleBurger");

      if (VueCookie.get("os_type") === "ios") {
        //trigger ios app switch
        this.iosAppSwitch(this.setBrand.unique_identifier);
      } else {
        //update cookies related to authentication
        let authCookie = localStorage.getItem(
          Cons[0].PATHS.NAME + Cons[0].PATHS.BRAND + "COOKIE"
        );
        localStorage.removeItem(
          Cons[0].PATHS.NAME + this.$route.params.brandSlug + "_COOKIE"
        );
        localStorage.setItem(
          Cons[0].PATHS.NAME + this.setBrand.unique_identifier + "_COOKIE",
          authCookie
        );
        //redirect to selected app
        this.$router.replace(`/${this.setBrand.unique_identifier}`);
        location.reload();
      }
    },
    showNotifications() {
      this.$router.push({ path: "/notifications" });
    },
    showCallToActionMenu(item) {
      if (process.env.VUE_APP_SITE == "https://www.tmalliance.ph/") {
        if (item.id == "8") {
          return false;
        }
      }
      return true;
    },
    showCallToAction() {
      if (this.userInfo && this.userInfo.user_type == "guest") return;
      this.$vlf
        .createInstance({
          storeName: "systemAlert"
        })
        .then(v => {
          this.$store.dispatch("systemAlert/getShareableActivity").then(res => {
            if (res && res.data.length > 0) {
              this.$vlf
                .createInstance({
                  storeName: "systemAlert"
                })
                .then(v => {
                  v.getItem("shareableActivity").then(activity => {
                    if (activity && activity.data && activity.data.length > 0) {
                      // exsiting to localstorage
                      // if( activity.id !== res.id ) {
                      if (this.checkNewData(res, activity)) {
                        // TODO NEW ACTIVITY POSTED
                        v.removeItem("remindLater");
                        v.setItem("shareableActivity", res);
                        this.$store.commit(
                          "systemAlert/setShareableActivity",
                          res
                        );
                        // this.$set(this, 'showSystemAlert', (res[0].user_action === null));
                        v.setItem("showAlert", true);
                      } else {
                        v.setItem("shareableActivity", res);
                        this.$store.commit(
                          "systemAlert/setShareableActivity",
                          res
                        );
                      }

                      v.getItem("showAlert").then(isShow => {
                        if (isShow) {
                          // showalert
                          this.$store.commit(
                            "systemAlert/setShareableActivity",
                            activity
                          );
                          v.setItem("showAlert", true);
                          // this.$set(this, 'showSystemAlert', (res[0].user_action === null));
                        } else {
                          // showalert (false)
                          if (this.checkNewData(res, activity)) {
                            v.setItem("shareableActivity", res);
                            this.$store.commit(
                              "systemAlert/setShareableActivity",
                              res
                            );
                            v.removeItem("remindLater");
                            clearInterval(checkReminder);
                          }

                          v.setItem(
                            "showAlert",
                            this.checkNewData(res, activity)
                          );
                          // this.$set(this, 'showSystemAlert', (((activity.length > 0 && activity[0] && res[0]) && activity[0].activity_id === res[0].activity_id) ? false:true) && (res[0].user_action === null));
                        }
                      });
                    } else {
                      // new stored to localstorage
                      v.setItem("shareableActivity", res);
                      this.$store.commit(
                        "systemAlert/setShareableActivity",
                        res
                      );
                      v.setItem("showAlert", res.data.length > 0);
                      // this.$set(this, 'showSystemAlert', ((res.length > 0) && (res[0].user_action === null)) ? true:false);
                    }
                  });
                });
            } else {
              this.$vlf
                .createInstance({
                  storeName: "systemAlert"
                })
                .then(v => {
                  this.$store.commit("systemAlert/setShareableActivity", {});
                  v.setItem("shareableActivity", {});
                  v.setItem("showAlert", false);
                });
            }
          });

          this.$store.commit("systemAlert/setShowSystemAlert", true);
          v.removeItem("remindLater");
          clearInterval(checkReminder);
        });
    },
    onCallToActionClose() {
      this.$vlf
        .createInstance({
          storeName: "systemAlert"
        })
        .then(v => {
          v.setItem("showAlert", false);
          this.$store.commit("systemAlert/setShowSystemAlert", false);
          v.removeItem("remindLater");
          clearInterval(checkReminder);
        });
    },
    setMemberMethod(type) {
      console.log(type);
      if (type === "signup") {
        if (
          VueCookie.get("os_type") === "ios" &&
          !VueCookie.get("ios_app_version")
        ) {
          window.webkit.messageHandlers.onNativeCalled.postMessage({
            name: "authRegister",
            params: {}
          });
          return false;
        }
        this.$router.replace({ path: "/login?type=signup" });
      } else {
        if (
          VueCookie.get("os_type") === "ios" &&
          !VueCookie.get("ios_app_version")
        ) {
          window.webkit.messageHandlers.onNativeCalled.postMessage({
            name: "authLogin",
            params: {}
          });
          return false;
        }
        this.$router.replace({ path: "/login?type=signin" });
      }
      // this.reportType = type
      // if(type == 'signin' || type == 'signup')
      //   this.$store.commit('menu/setShowWizardModalComponent', true)
    },
    showInviteOthers() {
      if (navigator.onLine) this.$store.commit("share/setShowInvite", true);
      else {
        this.$store.commit("share/setShowInvite", false);
        this.$store.commit("hitOffline");
      }

      // this.showInvite=true;
      // BroadcastEvent.$emit("onInvite");

      // this.viewPage('/home');
      // BroadcastEvent.$emit("onInvite");
    },
    dismiss() {
      BroadcastEvent.$emit("onToggleBurger");
    },
    viewPage(v, isLogin) {
      if (!v) return;
      if (
        isLogin &&
        VueCookie.get("os_type") === "ios" &&
        !VueCookie.get("ios_app_version")
      ) {
        window.webkit.messageHandlers.onNativeCalled.postMessage({
          name: "authLogin",
          params: {}
        });
        return false;
      }

      this.$vlf
        .createInstance({
          storeName: "systemAlert"
        })
        .then(v => {
          this.$store.commit("systemAlert/setShareableActivity", {});
          v.setItem("shareableActivity", {});
          v.setItem("showAlert", true);
        });
      // this.showCallToAction();

      if (v == "signout") {
        BroadcastEvent.$emit("onToggleBurger");
        this.$store.dispatch("base/signout", null, { root: 1 }).then(() => {
          this.$router.replace(`/${this.$route.params.brandSlug}/login`);
        });
      } else {
        this.$router.push({ path: v });
        BroadcastEvent.$emit("onToggleBurger");
      }
    },
    userDisplayImage(user) {
      return Utils.getDisplayImage("user", user, "medium");
    },
    openAboutModal() {
      // this.$store.commit('publicModule/setShowAboutMynd', true);
      this.$router.push(
        "/" +
          this.$route.params.brandSlug +
          "/feed/" +
          Cons[0].MENU_COMPONENT.about_sharpen
      );
    },
    checkNewData(data1, data2) {
      return (
        data1.data[0].id !== data2.data[0].id ||
        data1.data[0].updated_at !== data2.data[0].updated_at ||
        data1.data.length !== data2.data.length
      );
    }
  }
};
</script>
